const getEmailInputWidth = (value) => value?.length * 10 + 20;

export { getEmailInputWidth };
